<template>
  <CatalogCrudView
    title="Contas bancárias"
    subtitle="Identifique as contas reais por onde os recursos financeiros entram ou saem."
    singular="conta bancária"
    new-label="Nova conta bancária"
    list-title="Contas bancárias cadastradas"
    icon="bank"
    item-name-field="bankName"
    default-sort-by="ownerName"
    search-placeholder="Entidade, banco, agência, conta ou Pix"
    :service="service"
    :fields="fields"
    :columns="columns"
    :form-defaults="formDefaults"
  />
</template>

<script>
import Swal from 'sweetalert2'
import CatalogCrudView from '../components/CatalogCrudView.vue'
import service from '../services/bankAccountService'

export default {
  name: 'BankAccountsView',
  components: { CatalogCrudView },
  data: () => ({
    service,
    ownerOptions: [{ value: 0, label: 'Selecione a entidade', disabled: true }],
    formDefaults: { ownerId: 0, bankName: '', branchNumber: '', accountNumber: '', accountDigit: '', pixKey: '', isActive: true },
    columns: [
      { text: 'Id', value: 'id' }, { text: 'Entidade proprietária', value: 'ownerName', emphasis: true },
      { text: 'Banco', value: 'bankName' }, { text: 'Agência', value: 'branchNumber' },
      { text: 'Conta', value: 'accountNumber' }, { text: 'Dígito', value: 'accountDigit', sortable: false },
      { text: 'Chave Pix', value: 'pixKey' },
      { text: 'Situação', value: 'isActive', type: 'status' }, { text: 'Criado em', value: 'createdAt', type: 'date' }
    ]
  }),
  computed: {
    fields () {
      return [
        { key: 'ownerId', label: 'Entidade proprietária', required: true, type: 'select', options: this.ownerOptions, span: 5 },
        { key: 'bankName', label: 'Banco', required: true, maxlength: 100, placeholder: 'Ex.: Banco Itaú', span: 4 },
        { key: 'isActive', label: 'Situação', type: 'select', options: [{ value: true, label: 'Ativo' }, { value: false, label: 'Inativo' }], span: 3 },
        { key: 'branchNumber', label: 'Agência', maxlength: 20, placeholder: 'Ex.: 1234', span: 3 },
        { key: 'accountNumber', label: 'Número da conta', maxlength: 30, placeholder: 'Ex.: 12345', span: 4 },
        { key: 'accountDigit', label: 'Dígito', maxlength: 10, placeholder: 'Ex.: 6', span: 2 },
        { key: 'pixKey', label: 'Chave Pix', maxlength: 150, placeholder: 'CPF, CNPJ, e-mail, telefone ou chave aleatória', span: 3 }
      ]
    }
  },
  created () {
    this.loadOwnerOptions()
  },
  methods: {
    async loadOwnerOptions () {
      try {
        const options = await service.getOwnerOptions()
        this.ownerOptions = [
          { value: 0, label: 'Selecione a entidade', disabled: true },
          ...options.map(option => ({
            value: option.id,
            label: option.isActive ? option.name : `${option.name} (inativa)`,
            disabled: !option.isActive
          }))
        ]
      } catch (_) {
        await Swal.fire({ title: 'Atenção', text: 'Não foi possível carregar as entidades financeiras.', icon: 'error', confirmButtonColor: '#e77900' })
      }
    }
  }
}
</script>
